export const lastUpdateDate = '12.05';